export const industryOptions = [
	{ label: "Agriculture & Allied Industries", value: 6038 },
	{ label: "Beverage Industries", value: 6039 },
	{ label: "Canning Industry", value: 6040 },
	{ label: "Cargo Clearance & Forwarding Agents' (Burdnara) Employees", value: 6041 },
	{ label: "Cinemas & Theatres", value: 6042 },
	{ label: "Clay & Glass Products", value: 6043 },
	{ label: "Construction", value: 6044 },
	{ label: "Domestic Service", value: 6045 },
	{ label: "Electronics Industry", value: 6046 },
	{ label: "Food Manufacture Industries", value: 6047 },
	{ label: "Hire (Cars or Private Buses)", value: 6048 },
	{ label: "Hospitals & Clinics", value: 6049 },
	{ label: "Hotels & Clubs", value: 6050 },
	{ label: "Jewellery & Watches", value: 6052 },
	{ label: "Laundries", value: 6053 },
	{ label: "Leather Goods & Shoes Industries", value: 6054 },
	{ label: "Other", value: 8806 },
	{ label: "Paper, Plastics, Chemicals & Petroleum", value: 6055 },
	{ label: "Printing & Publishing", value: 6056 },
	{ label: "Private Cleaning Services", value: 6057 },
	{ label: "Private Schools", value: 6058 },
	{ label: "Private Security Services", value: 6059 },
	{ label: "Professional Office", value: 6036 },
	{ label: "Public Transport", value: 6060 },
	{ label: "Restaurants", value: 6051 },
	{ label: "Seamen", value: 6061 },
	{ label: "Sextons and Custodians", value: 6062 },
	{ label: "Textiles & Allied Industries", value: 6063 },
	{ label: "Tobacco Manufacture Industry", value: 6064 },
	{ label: "Transport Equipment, Metal & Allied Industries", value: 6065 },
	{ label: "Travel & Insurance Agencies", value: 6066 },
	{ label: "Wholesale & Retail Trades", value: 6067 },
	{ label: "Woodworks", value: 6068 },
];
